export const setDisplayedItems = (modelRepo, data, resetItems = true) => {
  if (resetItems) modelRepo.where((m) => m.isDisplayed === true).update({ isDisplayed: false });

  return modelRepo
    .where((m) => data?.find((item) => m.uuid === item.uuid))
    .update({ isDisplayed: true });
};
